module.exports = __webpack_public_path__ + "static/media/ZAUM_Logo_schwarz.80308917.jpg";